var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 8.148,
    height: 16.359,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6096",
    "data-name": "Group 6096",
    transform: "translate(-277 -2285)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_636",
    "data-name": "Rectangle 636",
    width: 36,
    height: 36,
    rx: 18,
    transform: "translate(277 2285)",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6070",
    "data-name": "Group 6070",
    transform: "translate(290.414 2294.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6038",
    "data-name": "Group 6038",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8527",
    "data-name": "Path 8527",
    d: "M2.37,9.054H0V6.147H2.361c0-.11,0-.2,0-.288,0-.768-.013-1.536.007-2.3A3.887,3.887,0,0,1,3,1.43,3.237,3.237,0,0,1,5.727.007c.8-.027,1.6.035,2.421.058V2.707c-.366,0-.731-.005-1.095,0a6.241,6.241,0,0,0-.764.043A.986.986,0,0,0,5.3,3.783c-.043.772-.01,1.548-.01,2.349H7.921L7.56,9.043H5.285v7.316H2.37Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4562ff9ceaf93a95e91303ba1a56e637.svg";
export { ForwardRef as ReactComponent };